export class DialogManageCN {
    constructor(
      public data: any
    ) {}
  }